import { Component } from '@angular/core';
//import { version } from '../../../package.json';
import packageInfo from '../../../package.json';

@Component({
  selector: '[eos-footer]',
  templateUrl: './footer.component.html',
  styleUrls: []
})
export class FooterComponent {
  thisYear = new Date().getFullYear();
  public version: string = packageInfo.version;
  constructor() { }
}
